import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, ElementRef, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CommonService } from '../../providers/common.service';
import { Menu, ModelDialogType } from '../../models/menu';
import { CustomTranslateService } from '../../providers/customTranslate.service';
import { MatIconRegistry } from '@angular/material/icon';
import { Constants } from '../../common/constants';
import { FormControl, Validators } from '@angular/forms';
import { SettingswithID, SettingsService } from '../../providers/settings.service';
import { DialogService } from '../../providers/dialogservice';
import { DomSanitizer } from '@angular/platform-browser';
import { LanguageSettings } from '../../providers/languageSettings.service';
import { SearchDataService } from '../../providers/searchDataService';
import { filter } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-landingmodule',
  templateUrl: './landingmodule.component.html',
  styleUrls: ['../bleclassmodule/bleclassmodule.css', 'landingmodule.component.css','../app-layout/app-layout.component.scss']
})
export class LandingModuleComponent implements OnInit {
  toggle: boolean;
  screenWidth: number;
  dark = false;
  menuList: Menu[] = [];
  darkThemeClass: string;

  /**
     * Trace the routerlink of the currently active component.
     */
  currentRoutePath: string;
  helpPath: string;

  platforms:String[];
  selectedPlatform:String='';

  dialogComponentInput: ModelDialogType = {
    type: null,
    message: ''
  };

  codeIcon:string='JavaScript_icon';

  private readonly WARNING: string = 'warning';
  private readonly SUCCESS: string = 'check_circle';
  private readonly ERROR: string = 'error';

  constructor(
    private commonsvc: CommonService,
    private router: Router,
    private dialog: MatDialog,
    private _element: ElementRef,
    private customTranslateSvc: CustomTranslateService,
    private _overlayContainer: OverlayContainer,
    private settingsSvc: SettingsService,
    private dialogService: DialogService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private languageSettings: LanguageSettings,
    private searchDataService: SearchDataService ) {
      this.matIconRegistry.addSvgIcon(
        "class_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/classIcon.svg")
      );
      this.matIconRegistry.addSvgIcon(
        "enum_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/enumIcon.svg")
      );
      this.matIconRegistry.addSvgIcon(
        "interface_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/interfaceIcon.svg")
      );
      this.matIconRegistry.addSvgIcon(
        "tutorial_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/tutorialsIcon.svg")
      );
      this.matIconRegistry.addSvgIcon(
        "Java_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/language-icons/java-svgrepo-com.svg")
      );
      this.matIconRegistry.addSvgIcon(
        "Swift_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/language-icons/swift-bird-shape-svgrepo-com.svg")
      );
      this.matIconRegistry.addSvgIcon(
        "JavaScript_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/language-icons/javascript-svgrepo-com.svg")
      );

      this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: any) => {
        this.currentRoutePath = this.router.url.slice(6);
      });
    }

  /**
    * Tracks the currently active page and updates the Help window content accordingly.
      */
  ngOnInit() {
      this.toggle = true;
      this.commonsvc.getMenuContent().subscribe(d => this.menuList = d);
      this.screenWidth = window.innerWidth;
      window.onresize = () => {
        this.screenWidth = window.innerWidth;
      };
      this.dialogService.getData().subscribe((data: ModelDialogType) => {
        this.setDialogInput(data);
      });
      this.platforms = this.languageSettings.getAllLanguages();
  }

  onTopClicked() {
    const top = document.getElementById('PageTop');
    if (top !== null) {
      top.scrollTo({top: 0, behavior: 'auto'});
      this.router.navigate(['/' + this.currentRoutePath.split('#')[0]], {fragment : 'PageTop'});
    }
  }


  gotoDashboard() {
    this.router.navigate(['/docs']);
  }


  toggleFullscreen() {
    const elem = this._element.nativeElement.querySelector('.demo-content');
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullScreen) {
      elem.webkitRequestFullScreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.msRequestFullScreen) {
      elem.msRequestFullScreen();
    }
  }

  /**
   * This function is used to set the input of the Dialog component
   */
  private setDialogInput(inputData: ModelDialogType) {
    this.dialogComponentInput = inputData;
    switch (inputData.type) {
      case 1:
        return this.dialogComponentInput.icon = this.SUCCESS;
      case 2:
        return this.dialogComponentInput.icon = this.WARNING;
      case 3:
        return this.dialogComponentInput.icon = this.ERROR;
    }
  }
}
